module.exports = {
  title: '厂商联宣传页',
  route: {
    path: '/factory-trade-union',
    children: {
      path: 'factory-trade-set-share',
    },
  },
};
